import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    currentUser: JSON.parse(localStorage.getItem('currentUser')) || {}
}
const usersSlice = createSlice({
    name:'users',
    initialState,
    reducers:{
        setCurrentUser:(state,{payload})=>{
            state.currentUser = payload
        }
    }
})

export const { setCurrentUser,} = usersSlice.actions
export default usersSlice.reducer